import sourceItemConnector from "../source-item-connector"
import SourceViewItem from "./SourceViewItem"

export default sourceItemConnector(SourceViewItem)
